import { composeCouponRouteTemplate } from '@/lib/coupon/gen-code'
import { DEFAULT_FREE_PRODUCT_COUPON } from '@/providers/coupon/FreeProductFormProvider'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/coupon/free-product')(
  composeCouponRouteTemplate(DEFAULT_FREE_PRODUCT_COUPON),
)
